import { Loading } from 'quasar'

Loading.show({
  ignoreDefaults: true,
  delay: 0,
  backgroundColor: 'white',
  spinnerColor: 'primary',
  spinnerSize: 200
})
